export const CURRENT_DEFAULT_FLAT_FEE = 7;
export const CURRENT_DEFAULT_FLAT_BASE_COST = 1;
export const CURRENT_DEFAULT_CUT = 0.015;

export const calculateRefund = (amount_due: number) => {
  return amount_due + calculateTotalFee(amount_due);
};

export const calculateTotalFee = (amount_due: number) => {
  // example structure of amount_due: "12.34 PLN"
  return parseFloat(
    (
      CURRENT_DEFAULT_FLAT_FEE +
      CURRENT_DEFAULT_FLAT_BASE_COST +
      amount_due * CURRENT_DEFAULT_CUT
    ).toFixed(2)
  );
};
